<template>
    <div class="workorder-list-container">
      <h1>Work Order List</h1>
  
      <div class="filter-section">
        <div class="filter-row">
          <div class="filter-field">
            <label for="dayFilter">Day:</label>
            <input type="number" id="dayFilter" v-model="filters.day" min="1" max="31" @change="applyFilters">
          </div>
          <div class="filter-field">
            <label for="monthFilter">Month:</label>
            <select id="monthFilter" v-model="filters.month" @change="applyFilters">
              <option value="">All Months</option>
              <option v-for="month in months" :key="month.value" :value="month.value">{{ month.text }}</option>
            </select>
          </div>
          <div class="filter-field">
            <label for="yearFilter">Year:</label>
            <select id="yearFilter" v-model="filters.year" @change="applyFilters">
              <option value="">All Years</option>
              <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
            </select>
          </div>
          <div class="filter-field">
            <label for="wTypeFilter">W. Type:</label>
            <select id="wTypeFilter" v-model="filters.wType" @change="applyFilters">
              <option value="">All Types</option>
              <option v-for="type in workTypes" :key="type.WorkTypeID" :value="type.WorkTypeID">{{ type.WorkTypeDescription }}</option>
            </select>
          </div>
          <div class="filter-field">
            <label for="wTradeFilter">W. Trade:</label>
            <select id="wTradeFilter" v-model="filters.wTrade" @change="applyFilters">
              <option value="">All Trades</option>
              <option v-for="trade in workTrades" :key="trade.WorkTradeID" :value="trade.WorkTradeID">{{ trade.WorkTrade }}</option>
            </select>
          </div>
          <div class="filter-field">
            <label for="wStatusFilter">W. Status:</label>
            <select id="wStatusFilter" v-model="filters.wStatus" @change="applyFilters">
              <option value="">All Statuses</option>
              <option v-for="status in workStatuses" :key="status.WorkStatusID" :value="status.WorkStatusID">{{ status.WorkStatus }}</option>
            </select>
          </div>
        </div>
  
        <div class="filter-row">
          <div class="filter-field">
            <label for="siteFilter">Site:</label>
            <select id="siteFilter" v-model="filters.siteCode" @change="fetchDepartmentsAndResetDependentFilters">
              <option value="">All Sites</option>
              <option v-for="site in sites" :key="site.SiteCode" :value="site.SiteCode">{{ site.SiteCode }}</option>
            </select>
          </div>
           <div class="filter-field">
            <label for="departmentFilter">Department:</label>
            <select id="departmentFilter" v-model="filters.departmentNo" :disabled="!filters.siteCode" @change="fetchLocationsAndResetDependentFilters">
              <option value="">All Departments</option>
              <option v-for="department in filteredDepartments" :key="department.dep_no" :value="department.dep_no">{{ department.dep_desc }} ({{ department.dep_no }})</option>
            </select>
          </div>
           <div class="filter-field">
            <label for="locationFilter">Location:</label>
            <select id="locationFilter" v-model="filters.locationNo" :disabled="!filters.departmentNo" @change="fetchAssetsAndResetDependentFilters">
              <option value="">All Locations</option>
              <option v-for="location in filteredLocations" :key="location.loc_no" :value="location.loc_no">{{ location.loc_desc }} ({{ location.loc_no }})</option>
            </select>
          </div>
          <div class="filter-field">
            <label for="assetFilter">Asset:</label>
            <select id="assetFilter" v-model="filters.assetNo" :disabled="!filters.locationNo" @change="applyFilters">
              <option value="">All Assets</option>
               <option v-for="asset in filteredAssets" :key="asset.asset_no" :value="asset.asset_no">{{ asset.asset_desc }} ({{ asset.asset_no }})</option>
            </select>
          </div>
           <div class="filter-field">
            <label for="woNoFilter">WO No:</label>
            <input type="text" id="woNoFilter" v-model="filters.woNo" @input="debounceApplyFilters">
          </div>
          <div class="filter-field filter-buttons">
              <button class="today-button" @click="setToday">Today</button>
              <button class="clear-filters-button" @click="clearFilters">Clear Filters</button>
          </div>
        </div>
      </div>
  
      
  
      <div class="workorder-table-container">
        <div class="action-buttons">
        <!-- <button @click="printPreview">Print Preview</button> -->
        <button @click="printList">Print</button>
        <button @click="exportToExcel">Export to Excel</button>
      </div>
        <table class="workorder-table" ref="workOrderTable">
          <thead>
            <tr>
              <th>WorkorderNo</th>
              <th>EmployeeNo</th>
              <th>AssetNo</th>
              <th>LocationNo</th>
              <th>Date Received</th>
              <th>W.Type</th>
              <th>W.Status</th>
              <th>Start Date</th>
              <th>WOTrade</th>
              <th>PMNo</th>
              <th>TaskNo</th>
              <th>SiteCode</th>
               </tr>
          </thead>
          <tbody>
            <tr v-if="loading">
              <td colspan="12" class="loading-row">Loading work orders...</td>
            </tr>
            <tr v-else-if="workorders.length === 0">
              <td colspan="12" class="no-data-row">No work orders found matching filters.</td>
            </tr>
            <tr v-else v-for="wo in workorders" :key="wo.id" @dblclick="viewWorkOrderDetails(wo)">
              <td>{{ wo.WorkorderNo }}</td>
              <td>{{ wo.EmployeeNo }}</td>
              <td>{{ wo.AssetNo }}</td>
              <td>{{ wo.LocationNo }}</td>
              <td>{{ formatDate(wo.DateReceived) }}</td>
              <td>{{ getWorkTypeDescription(wo.WorkType) }}</td>
              <td>{{ getWorkStatusDescription(wo.WorkStatus) }}</td>
              <td>{{ formatDate(wo.StartDate) }}</td>
              <td>{{ getWorkTradeDescription(wo.WOTrade) }}</td>
              <td>{{ wo.PMNo }}</td>
              <td>{{ wo.TaskNo }}</td>
              <td>{{ wo.SiteCode }}</td>
               </tr>
          </tbody>
        </table>
      </div>
  
      <div v-if="isDetailsModalOpen" class="modal-overlay" @click.self="closeDetailsModal">
          <div class="modal-content">
              <div class="modal-header">
                  <h3>Work Order Details: {{ selectedWorkOrder ? selectedWorkOrder.WorkorderNo : '' }}</h3>
                  <button class="close-button" @click="closeDetailsModal">×</button>
              </div>
              <div v-if="selectedWorkOrder" class="modal-body work-order-details">
                  <div class="detail-field">
                      <label>Workorder No:</label>
                      <span>{{ selectedWorkOrder.WorkorderNo }}</span>
                  </div>
                   <div class="detail-field">
                      <label>Employee No:</label>
                      <span>{{ selectedWorkOrder.EmployeeNo }}</span>
                  </div>
                   <div class="detail-field">
                      <label>Asset No:</label>
                      <span>{{ selectedWorkOrder.AssetNo }}</span>
                  </div>
                   <div class="detail-field">
                      <label>Location No:</label>
                      <span>{{ selectedWorkOrder.LocationNo }}</span>
                  </div>
                   <div class="detail-field">
                      <label>Date Received:</label>
                      <span>{{ formatDate(selectedWorkOrder.DateReceived) }}</span>
                  </div>
                   <div class="detail-field">
                      <label>Work Type:</label>
                      <span>{{ getWorkTypeDescription(selectedWorkOrder.WorkType) }}</span>
                  </div>
                   <div class="detail-field">
                      <label>W. Status:</label>
                       <div class="status-and-button">
                           <span>{{ getWorkStatusDescription(selectedWorkOrder.WorkStatus) }}</span>
                           <button v-if="selectedWorkOrder.WorkStatus !== getWorkStatusId('Closed')" class="close-wo-button" @click="closeWorkOrder">Close WO</button>
                      </div>
                  </div>
                   <div class="detail-field">
                      <label>Start Date:</label>
                      <span>{{ formatDate(selectedWorkOrder.StartDate) }}</span>
                  </div>
                   <div class="detail-field">
                      <label>WO Trade:</label>
                      <span>{{ getWorkTradeDescription(selectedWorkOrder.WOTrade) }}</span>
                  </div>
                   <div class="detail-field">
                      <label>PM No:</label>
                      <span>{{ selectedWorkOrder.PMNo }}</span>
                  </div>
                   <div class="detail-field">
                      <label>Task No:</label>
                      <span>{{ selectedWorkOrder.TaskNo }}</span>
                  </div>
                   <div class="detail-field">
                      <label>Site Code:</label>
                      <span>{{ selectedWorkOrder.SiteCode }}</span>
                  </div>
  
                  <div class="detail-field">
                      <label for="actualStartDate">Actual Start Date:</label>
                       <input type="date" id="actualStartDate" v-model="actualStartDate" :disabled="selectedWorkOrder.WorkStatus === getWorkStatusId('Closed')">
                  </div>
                   <div class="detail-field">
                      <label for="workDuration">Work Duration (Hours):</label>
                       <input type="number" id="workDuration" v-model="workDuration" min="0" :disabled="selectedWorkOrder.WorkStatus === getWorkStatusId('Closed')">
                  </div>
                   <div class="detail-field">
                      <label for="actualEndDate">Actual End Date:</label>
                       <input type="date" id="actualEndDate" v-model="actualEndDate" :disabled="selectedWorkOrder.WorkStatus === getWorkStatusId('Closed')">
                  </div>
                   <div class="detail-field">
                      <label for="clientSatisfaction">Client Satisfaction:</label>
                       <select id="clientSatisfaction" v-model="clientSatisfaction" :disabled="selectedWorkOrder.WorkStatus === getWorkStatusId('Closed')">
                           <option value="">Select Satisfaction</option>
                           <option value="Excellent">Excellent</option>
                           <option value="Good">Good</option>
                           <option value="Fair">Fair</option>
                           <option value="Poor">Poor</option>
                           </select>
                  </div>
                   <div class="detail-field full-width">
                      <label for="finalSituation">Final Situation:</label>
                       <textarea id="finalSituation" v-model="finalSituation" :disabled="selectedWorkOrder.WorkStatus === getWorkStatusId('Closed')"></textarea>
                  </div>
  
                  </div>
               <div class="modal-footer">
                  <button @click="closeDetailsModal">Close</button>
              </div>
          </div>
      </div>
  
  
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  import debounce from 'lodash.debounce';
  import * as XLSX from 'xlsx';
  import { API_BASE_URL } from '@/config';
  
  
  export default {
    name: 'WorkorderListView',
    data() {
      const currentYear = new Date().getFullYear();
      const years = Array.from({ length: 16 }, (_, i) => currentYear - 10 + i);
  
      return {
        workorders: [],
        sites: [],
        workTypes: [],
        workTrades: [],
        workStatuses: [], // Fetched from backend
  
        filteredDepartments: [],
        filteredLocations: [],
        filteredAssets: [],
  
        months: [
          { value: 1, text: 'January' }, { value: 2, text: 'February' }, { value: 3, text: 'March' },
          { value: 4, text: 'April' }, { value: 5, text: 'May' }, { value: 6, text: 'June' },
          { value: 7, text: 'July' }, { value: 8, text: 'August' }, { value: 9, text: 'September' },
          { value: 10, text: 'October' }, { value: 11, text: 'November' }, { value: 12, text: 'December' },
        ],
        years: years,
  
        filters: {
          day: null, month: '', year: '', wType: '', wTrade: '', wStatus: '',
          siteCode: '', departmentNo: '', locationNo: '', assetNo: '', woNo: '',
        },
        loading: false,
        currentYear: currentYear,
  
        // State for the Work Order Details modal
        isDetailsModalOpen: false,
        selectedWorkOrder: null, // To hold the data of the work order being viewed
  
        // Data properties for the new fields in the modal
        actualStartDate: null,
        actualEndDate: null,
        workDuration: null,
        clientSatisfaction: '',
        finalSituation: '',
      };
    },
    created() {
      this.fetchInitialFilterData();
      this.fetchWorkorders();
    },
    methods: {
      async fetchInitialFilterData() {
        try {
          const [sitesRes, workTypesRes, workTradesRes, workStatusesRes] = await Promise.all([
            axios.get(`${API_BASE_URL}/api/sites`),
            axios.get(`${API_BASE_URL}/api/workorders/worktypes`),
            axios.get(`${API_BASE_URL}/api/workorders/worktrades`),
            axios.get(`${API_BASE_URL}/api/workstatuses`), // Fetch work statuses
          ]);
          this.sites = sitesRes.data;
          this.workTypes = workTypesRes.data;
          this.workTrades = workTradesRes.data;
          this.workStatuses = workStatusesRes.data; // Populate workStatuses
          console.log('Fetched initial filter data:', {sites: this.sites, workTypes: this.workTypes, workTrades: this.workTrades, workStatuses: this.workStatuses});
  
        } catch (error) {
          console.error('Error fetching initial filter data:', error);
          alert('Failed to load initial filter data.');
        }
      },
  
      async fetchDepartmentsAndResetDependentFilters() {
          this.filters.departmentNo = ''; this.filters.locationNo = ''; this.filters.assetNo = '';
          this.filteredDepartments = []; this.filteredLocations = []; this.filteredAssets = [];
          if (this.filters.siteCode) {
              try {
                  const response = await axios.get(`${API_BASE_URL}/api/departments/bysite/${this.filters.siteCode}`);
                  this.filteredDepartments = response.data;
                  console.log(`Fetched departments for site ${this.filters.siteCode}:`, this.filteredDepartments);
              } catch (error) {
                  console.error('Error fetching filtered departments:', error);
                  alert('Failed to load departments for the selected site.');
                  this.filteredDepartments = [];
              }
          }
          this.applyFilters();
      },
  
      async fetchLocationsAndResetDependentFilters() {
         this.filters.locationNo = ''; this.filters.assetNo = '';
         this.filteredLocations = []; this.filteredAssets = [];
         console.log('Attempting to fetch locations for DepartmentNo:', this.filters.departmentNo);
        if (this.filters.departmentNo) {
          try {
            const response = await axios.get(`${API_BASE_URL}/api/locations`, { params: { departmentId: this.filters.departmentNo } });
            this.filteredLocations = response.data;
            console.log(`Fetched locations for DepartmentNo ${this.filters.departmentNo}:`, this.filteredLocations);
          } catch (error) {
            console.error('Error fetching locations:', error);
             alert('Error fetching locations. Please ensure the /api/locations endpoint supports filtering by departmentId.');
          }
        }
         this.applyFilters();
      },
  
      async fetchAssetsAndResetDependentFilters() {
         this.filters.assetNo = '';
         this.filteredAssets = [];
         console.log('Attempting to fetch assets for LocationNo:', this.filters.locationNo);
        if (this.filters.locationNo) {
          try {
            const response = await axios.get(`${API_BASE_URL}/api/assets`, { params: { locationId: this.filters.locationNo } });
             this.filteredAssets = response.data;
             console.log(`Fetched assets for LocationNo ${this.filters.locationNo}:`, this.filteredAssets);
          } catch (error) {
            console.error('Error fetching assets:', error);
             alert('Error fetching assets. Please ensure the /api/assets endpoint supports filtering by locationId.');
          }
        }
         this.applyFilters();
      },
  
      async fetchWorkorders() {
        this.loading = true;
        try {
          const params = {};
          for (const key in this.filters) {
            if (this.filters[key] !== '' && this.filters[key] !== null) {
              params[key] = this.filters[key];
            }
          }
          console.log('Fetching work orders with filters:', params);
  
          const response = await axios.get(`${API_BASE_URL}/api/workorderslist`, { params });
  
          this.workorders = response.data;
          console.log('Fetched work orders (raw data):', this.workorders);
  
        } catch (error) {
          console.error('Error fetching work orders:', error);
          alert('Failed to load work orders.');
          this.workorders = [];
        } finally {
          this.loading = false;
        }
      },
  
      applyFilters() {
        this.fetchWorkorders();
      },
  
      debounceApplyFilters: debounce(function() {
          this.applyFilters();
      }, 500),
  
      clearFilters() {
          this.filters = {
              day: null, month: '', year: '', wType: '', wTrade: '', wStatus: '',
              siteCode: '', departmentNo: '', locationNo: '', assetNo: '', woNo: '',
          };
          this.filteredDepartments = []; this.filteredLocations = []; this.filteredAssets = [];
          this.fetchWorkorders();
          console.log('Filters cleared.');
      },
  
      setToday() {
          const today = new Date();
          this.filters.day = today.getDate();
          this.filters.month = today.getMonth() + 1;
          this.filters.year = today.getFullYear();
          this.applyFilters();
          console.log('Filters set to today:', this.filters);
      },
  
      // --- Print/Export Methods ---
      printPreview() {
        window.print();
         console.log('Triggered print preview (browser print dialog).');
      },
  
      printList() {
        const printWindow = window.open('', '_blank');
        if (printWindow) {
            printWindow.document.write('<html><head><title>Work Order List</title>');
            const styles = document.querySelectorAll('link[rel="stylesheet"], style');
            styles.forEach(style => { printWindow.document.write(style.outerHTML); });
             printWindow.document.write(`
                 <style>
                     body { font-family: Arial, sans-serif; margin: 20px; }
                     table { width: 100%; border-collapse: collapse; margin-bottom: 20px; }
                     th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
                     th { background-color: #f2f2f2; font-weight: bold; }
                     tr:nth-child(even) { background-color: #f9f9f9; }
                     .filter-section, .action-buttons { display: none; }
                 </style>
             `);
            printWindow.document.write('</head><body>');
            const tableHtml = this.$refs.workOrderTable.outerHTML;
            printWindow.document.write('<h1>Work Order List</h1>');
            printWindow.document.write(tableHtml);
            printWindow.document.write('</body></html>');
            printWindow.document.close();
            printWindow.onload = () => { printWindow.print(); };
        } else {
            alert('Please allow pop-ups to print the table.');
        }
         console.log('Triggered print for table only.');
      },
  
      exportToExcel() {
        if (this.workorders.length === 0) {
          alert('No data to export.');
          return;
        }
        if (typeof XLSX === 'undefined') {
            alert('Excel export library not loaded. Please check the application setup.');
            console.error('SheetJS (XLSX) library is not available.');
            return;
        }
  
        const dataForExport = this.workorders.map(wo => {
            return {
                'WorkorderNo': wo.WorkorderNo,
                'EmployeeNo': wo.EmployeeNo,
                'AssetNo': wo.AssetNo,
                'LocationNo': wo.LocationNo,
                'Date Received': this.formatDate(wo.DateReceived),
                'W.Type': this.getWorkTypeDescription(wo.WorkType),
                'W.Status': this.getWorkStatusDescription(wo.WorkStatus),
                'Start Date': this.formatDate(wo.StartDate),
                'WOTrade': this.getWorkTradeDescription(wo.WOTrade),
                'PMNo': wo.PMNo,
                'TaskNo': wo.TaskNo,
                'SiteCode': wo.SiteCode,
            };
        });
        const worksheet = XLSX.utils.json_to_sheet(dataForExport);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Work Orders');
        XLSX.writeFile(workbook, 'workorder_list.xlsx');
        console.log('Exported data to workorder_list.xlsx');
      },
  
      // --- Work Order Details Modal Methods ---
  
      // Method to open the details modal
      viewWorkOrderDetails(workOrder) {
          this.selectedWorkOrder = workOrder; // Store the clicked work order object
  
          // Populate the new fields with existing data if available, or default values
          this.actualStartDate = workOrder.ActualStartDate ? new Date(workOrder.ActualStartDate).toISOString().substr(0, 10) : null;
          this.actualEndDate = workOrder.ActualEndDate ? new Date(workOrder.ActualEndDate).toISOString().substr(0, 10) : null;
          this.workDuration = workOrder.WorkDuration || null; // Assuming WorkDuration is a number
          this.clientSatisfaction = workOrder.ClientSatisfaction || ''; // Assuming ClientSatisfaction is a string
          this.finalSituation = workOrder.FinalSituation || ''; // Assuming FinalSituation is a string
  
          this.isDetailsModalOpen = true; // Open the modal
          console.log('Viewing details for Work Order:', workOrder);
      },
  
      // Method to close the details modal
      closeDetailsModal() {
          this.isDetailsModalOpen = false; // Close the modal
          this.selectedWorkOrder = null; // Clear the selected work order data
          // Reset the new fields when closing the modal
          this.actualStartDate = null;
          this.actualEndDate = null;
          this.workDuration = null;
          this.clientSatisfaction = '';
          this.finalSituation = '';
  
          console.log('Details modal closed.');
      },
  
      // Method to get the Work Status ID for a given description
      getWorkStatusId(description) {
          const status = this.workStatuses.find(status => status.WorkStatus === description);
          return status ? status.WorkStatusID : null;
      },
  
  
      // Method to close the work order
      async closeWorkOrder() {
          if (!this.selectedWorkOrder) {
              console.error('No work order selected to close.');
              return;
          }
  
          // Get the ID for the "Closed" status
          const closedStatusId = this.getWorkStatusId('Closed');
          if (closedStatusId === null) {
              alert('Could not find the ID for "Closed" status. Please check work status data.');
              console.error('Work Status ID for "Closed" not found.');
              return;
          }
  
          // Prepare data to send to the backend for update
          const updatedData = {
              // Include necessary fields for identification (like ID)
              id: this.selectedWorkOrder.id, // Assuming 'id' is the primary key
              // Update the status to "Closed"
              WorkStatusID: closedStatusId, // Assuming backend expects WorkStatusID
  
              // Include the values from the new fields
              ActualStartDate: this.actualStartDate,
              ActualEndDate: this.actualEndDate,
              WorkDuration: this.workDuration,
              ClientSatisfaction: this.clientSatisfaction,
              FinalSituation: this.finalSituation,
  
              // You might need to include other fields here depending on your backend update logic
              // e.g., WorkorderNo, EmployeeNo, etc., if the backend requires them for the update query.
              // For a simple status/date update, ID and the changed fields should be enough.
          };
  
          console.log('Attempting to close Work Order:', this.selectedWorkOrder.WorkorderNo, 'with data:', updatedData);
  
          try {
              // --- API Call to Update Work Order ---
              // Assuming you have a backend endpoint for updating work orders by ID, e.g., PUT /api/workorders/:id
              const response = await axios.put(`${API_BASE_URL}/api/workorders/${this.selectedWorkOrder.id}`, updatedData); // Assuming PUT method and endpoint structure
  
              console.log('Work Order updated successfully:', response.data);
              alert(`Work Order ${this.selectedWorkOrder.WorkorderNo} closed successfully!`);
  
              // Refresh the work order list to show the updated status
              this.fetchWorkorders();
  
              // Close the modal
              this.closeDetailsModal();
  
          } catch (error) {
              console.error('Error closing work order:', error);
               // Provide more specific error message if available from backend
              const errorMessage = error.response && error.response.data ? error.response.data : 'Failed to close work order.';
              alert('Failed to close work order: ' + errorMessage);
          }
      },
  
  
      formatDate(dateString) {
        if (!dateString) return 'N/A';
        // Check if dateString is a valid date before formatting
        const date = new Date(dateString);
        if (isNaN(date.getTime())) {
            return 'Invalid Date';
        }
        const options = { year: 'numeric', month: 'short', day: 'numeric' };
        return date.toLocaleDateString('en-US', options);
      },
  
      getWorkTypeDescription(workTypeId) {
          const workType = this.workTypes.find(type => type.WorkTypeID === workTypeId);
          return workType ? workType.WorkTypeDescription : 'Unknown Type';
      },
  
      getWorkStatusDescription(workStatusId) {
          const workStatus = this.workStatuses.find(status => status.WorkStatusID === workStatusId);
          return workStatus ? workStatus.WorkStatus : 'Unknown Status';
      },
  
      getWorkTradeDescription(workTradeId) {
          const workTrade = this.workTrades.find(trade => trade.WorkTradeID === workTradeId);
          return workTrade ? workTrade.WorkTrade : 'Unknown Trade';
      },
    },
  };
  </script>
  
  <style scoped>
  /* Basic Styling (similar to WorkOrdersView for consistency) */
  .workorder-list-container {
    padding: 20px;
    font-family: Arial, sans-serif;
    background-color: #f4f7f6;
    border-radius: 8px;
    max-width: 1200px; /* Wider container for the list */
    margin: 20px auto;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }
  
  h1 {
    text-align: center;
    color: #333;
    margin-bottom: 20px;
    font-size: 24px;
  }
  
  .filter-section {
    background-color: #fff;
    padding: 15px;
    border-radius: 8px;
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.05);
    margin-bottom: 20px;
  }
  
  .filter-row {
    display: flex;
    flex-wrap: wrap;
    gap: 15px; /* Smaller gap for filters */
    margin-bottom: 15px;
  }
  
  .filter-field {
    flex: 1; /* Allow fields to grow */
    min-width: 150px; /* Minimum width for filter fields */
    display: flex;
    flex-direction: column;
  }
  
  .filter-field label {
    font-weight: bold;
    margin-bottom: 4px;
    color: #555;
    font-size: 13px;
  }
  
  .filter-field input[type="text"],
  .filter-field input[type="number"],
  .filter-field select {
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 13px;
    width: 100%;
    box-sizing: border-box;
  }
  
  .filter-field select:disabled {
      background-color: #f0f0f0;
      cursor: not-allowed;
  }
  
  /* Container for Today and Clear buttons */
  .filter-field.filter-buttons {
      flex-direction: row; /* Arrange buttons horizontally */
      align-items: flex-end; /* Align buttons to the bottom */
      gap: 10px; /* Space between buttons */
  }
  
  /* Style for the Today button */
  .today-button {
      padding: 8px 15px;
      background-color: #17a2b8; /* Info color */
      color: white;
      border: none;
      border-radius: 4px;
      cursor: pointer;
      font-size: 13px;
      transition: background-color 0.2s ease;
  }
  
  .today-button:hover {
      background-color: #138496; /* Darker info on hover */
  }
  
  
  /* Style for the Clear Filters button */
  .clear-filters-button {
      padding: 8px 15px;
      background-color: #f44336; /* Red color */
      color: white;
      border: none;
      border-radius: 4px;
      cursor: pointer;
      font-size: 13px;
      transition: background-color 0.2s ease;
  }
  
  .clear-filters-button:hover {
      background-color: #d32f2f; /* Darker red on hover */
  }
  
  
  .workorder-table-container {
    overflow-x: auto; /* Add horizontal scroll for table on small screens */
    margin-bottom: 20px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.05);
    padding: 15px;
  }
  
  .workorder-table {
    width: 100%;
    border-collapse: collapse;
    min-width: 800px; /* Ensure table is wide enough to prevent excessive squeezing */
  }
  
  .workorder-table th,
  .workorder-table td {
    border: 1px solid #ddd;
    padding: 10px;
    text-align: left;
    font-size: 14px;
  }
  
  .workorder-table th {
    background-color: #f2f2f2;
    font-weight: bold;
    color: #333;
  }
  
  .workorder-table tbody tr:nth-child(even) {
    background-color: #f9f9f9;
  }
  
  /* Add pointer cursor to table rows to indicate double-clickability */
  .workorder-table tbody tr {
      cursor: pointer;
  }
  
  .workorder-table tbody tr:hover {
    background-color: #e9e9e9;
  }
  
  .loading-row td,
  .no-data-row td {
      text-align: center;
      font-style: italic;
      color: #777;
  }
  
  
  .action-buttons {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    padding: 15px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.05);
    margin-bottom: 20px;
  }
  
  .action-buttons button {
    padding: 10px 15px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    transition: background-color 0.2s ease;
  }
  
  .action-buttons button:nth-child(1) { /* Print Preview */
      background-color: #007bff;
      color: white;
  }
  .action-buttons button:nth-child(1):hover {
      background-color: #0056b3;
  }
  
  .action-buttons button:nth-child(2) { /* Print */
      background-color: #28a745;
      color: white;
  }
  .action-buttons button:nth-child(2):hover {
      background-color: #218838;
  }
  
  .action-buttons button:nth-child(3) { /* Export */
      background-color: #ffc107;
      color: #333;
  }
  .action-buttons button:nth-child(3):hover {
      background-color: #e0a800;
  }
  
  
  /* Responsive adjustments */
  @media (max-width: 768px) {
    .filter-row {
      flex-direction: column;
      gap: 10px;
    }
  
    .filter-field {
      min-width: 100%;
    }
  
    .filter-field.filter-buttons {
         flex-direction: row;
         justify-content: space-around;
         align-items: center;
         margin-top: 10px;
     }
  
      .filter-field.filter-buttons button {
          flex-grow: 1;
          text-align: center;
      }
  
  
    .action-buttons {
        flex-direction: column;
        align-items: stretch;
    }
  
    .action-buttons button {
        width: 100%;
    }
  }
  
  /* --- Work Order Details Modal Styles --- */
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000; /* Ensure modal is on top */
  }
  
  .modal-content {
    background-color: #fff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    width: 90%;
    max-width: 700px; /* Increased max-width for more details */
    max-height: 80vh; /* Limit modal height */
    overflow-y: auto; /* Add scroll if content overflows */
    display: flex;
    flex-direction: column;
  }
  
  .modal-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #eee;
      padding-bottom: 10px;
      margin-bottom: 15px;
  }
  
  .modal-header h3 {
      margin: 0;
      font-size: 1.2rem;
  }
  
  .modal-body.work-order-details {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); /* Layout fields in columns */
      gap: 15px; /* Space between fields */
      margin-bottom: 15px;
  }
  
  .detail-field {
      display: flex;
      flex-direction: column;
  }
  
  .detail-field label {
      font-weight: bold;
      margin-bottom: 4px;
      color: #555;
      font-size: 13px;
  }
  
  .detail-field span,
  .detail-field input[type="text"],
  .detail-field input[type="date"],
  .detail-field input[type="number"],
  .detail-field select,
  .detail-field textarea {
      background-color: #f9f9f9; /* Light background for value */
      padding: 8px;
      border: 1px solid #eee;
      border-radius: 4px;
      word-break: break-word; /* Prevent long values from overflowing */
  }
  
  .detail-field input:disabled,
  .detail-field select:disabled,
  .detail-field textarea:disabled {
      background-color: #e9e9e9;
      cursor: not-allowed;
  }
  
  
  .detail-field.full-width {
      grid-column: 1 / -1; /* Make this field span all columns */
  }
  
  .status-and-button {
      display: flex;
      align-items: center;
      gap: 10px; /* Space between status span and button */
  }
  
  .status-and-button span {
      flex-grow: 1; /* Allow status span to take up available space */
  }
  
  /* Style for the Close WO button */
  .close-wo-button {
      padding: 5px 10px;
      background-color: #ff9800; /* Orange color */
      color: white;
      border: none;
      border-radius: 4px;
      cursor: pointer;
      font-size: 13px;
      transition: background-color 0.2s ease;
  }
  
  .close-wo-button:hover {
      background-color: #f57c00; /* Darker orange on hover */
  }
  
  
  .modal-footer {
      border-top: 1px solid #eee;
      padding-top: 10px;
      text-align: right;
  }
  
  .modal-footer button {
      padding: 8px 15px;
      background-color: #ccc;
      border: none;
      border-radius: 4px;
      cursor: pointer;
  }
  
  .modal-footer button:hover {
      background-color: #bbb;
  }
  
  .close-button {
      background: none;
      border: none;
      font-size: 1.5rem;
      cursor: pointer;
      color: #666;
      transition: color 0.2s ease;
  }
  
  .close-button:hover {
      color: #333;
  }
  
  </style>
  